import { Component, ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-telegram-bg flex items-center justify-center p-6">
          <div className="flex flex-col items-center text-center max-w-xs">
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mb-4">
              <AlertTriangle size={28} className="text-red-500" />
            </div>
            <h1 className="text-lg font-bold text-telegram-text mb-2">Что-то пошло не так</h1>
            <p className="text-sm text-telegram-hint mb-6">
              Произошла непредвиденная ошибка. Попробуйте перезагрузить приложение.
            </p>
            <button
              onClick={this.handleReload}
              className="flex items-center gap-2 px-6 py-3 bg-telegram-button text-white rounded-xl font-medium active:scale-95 transition-transform"
            >
              <RefreshCw size={16} />
              Перезагрузить
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
